"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _scene = require("../../utils/scene/scene");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper/broadcastSourceHelper");
var _SceneLayouts = require("../../constants/SceneLayouts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Create a scene where a single source takes up the entire display area of
 * the scene.
 * @param {{}} source
 * @param {{}} sourceStyle
 */
function singleBuilder(source) {
  var sourceStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var titleAndDesc = source ? source.title : _SceneLayouts.SINGLE.title;
  var sceneHeight = _scene.SCENE_HEIGHT;
  var sceneWidth = _scene.SCENE_WIDTH;
  var mediaStyle = {
    width: 'inherit',
    height: 'inherit',
    objectFit: source && (0, _broadcastSourceHelper.isMediaSource)(source) ? 'contain' : 'cover'
  };
  return {
    // TODO: remove as it is unnecessary and unused and probably will be confused w/ mongo object IDs
    _id: 'sceneSingleSource',
    title: titleAndDesc,
    description: titleAndDesc,
    style: _objectSpread({}, _scene.COMMON_SCENE_STYLES),
    layers: source ? [{
      _id: 'source1',
      source: source,
      layer: {
        animation: _objectSpread(_objectSpread({}, _scene.HARD_CUT_ANIMATION), {}, {
          animate: _objectSpread(_objectSpread({}, _scene.HARD_CUT_ANIMATION.animate), {}, {
            top: 0,
            left: 0,
            width: sceneWidth,
            height: sceneHeight
          })
        }),
        style: _objectSpread(_objectSpread({}, sourceStyle), {}, {
          top: 0,
          padding: 0,
          mediaStyle: mediaStyle,
          zIndex: 'auto',
          width: sceneWidth,
          objectFit: 'cover',
          height: sceneHeight,
          position: 'absolute',
          bannerStyles: {
            left: 0,
            bottom: 20,
            zIndex: 'auto',
            position: 'absolute',
            maxWidth: sceneWidth
          },
          bannerAnimation: _objectSpread(_objectSpread({}, _scene.PRESENTER_BANNER_ANIMATION), {}, {
            animate: _objectSpread(_objectSpread({}, _scene.PRESENTER_BANNER_ANIMATION.animate), {}, {
              top: sceneHeight - 80,
              left: 0
            })
          })
        })
      }
    }] : []
  };
}
var _default = exports["default"] = singleBuilder;